<template>
    <div class="dialog-mask evidences-dialog" :class="{ open: isOpen }">
        <div class="dialog-content">
            <div class="dialog-header">{{ 'DocumentsDetail' | lang }}</div>
            <div class="dialog-body">
                <div class="multi-nav singlecol">
                    <div v-for="(ev, j) in evidences[0].Evidences" :key="j">
                        <div v-content-attached-on-top class="nav-header hflex" :key="'h' + ev.Id">{{ ev.EvidenceType.Label }}
                        </div>
                        <ul class="nav" :key="ev.Id + 'nav'">
                            <li class="space-between"><span>{{ 'ActionType' | lang }}</span><span>{{ 'action_' + ev.ActionType |
                                lang }}</span></li>
                            <li class="space-between"><span>{{ 'FileStatus' | lang }}</span><span>{{ 'state_' + ev.State | lang
                            }}</span></li>
                            <li class="space-between"><span>{{ 'SendingStatus' | lang }}</span><span>{{
                                'supplyState_' + ev.SupplyState | lang }}</span></li>
                            <li v-for="(doc, d) in ev.Documents" class="space-between">
                                <span>{{ 'LoadedFile' | lang }}</span><span>{{ doc.Name }}</span>
                            </li>
                            <li v-if="ev.State == stateRefused && documentsNeeded[j]" class="space-between">
                                <span>
                                    <br />
                                    <label class="asButton">

                                        {{ 'Change' | lang }}

                                        <input type="file" @change="chooseFile($event, j)"
                                            :accept="manifest.document.acceptFormats" />

                                        <p v-if="documentsNeeded[j].Documents.length > 0">
                                            {{ documentsNeeded[j].Documents[0].Name || '-' }}</p>

                                        <p v-if="documentsNeeded[j].Documents.length > 0">
                                            {{ documentsNeeded[j].Documents[0].Size | humanFileSize }}</p>

                                    </label>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="dialog-footer">
                <button @click="sweetClose(false)">{{ 'Close' | lang }}</button>
                <button v-if="adding" :disabled="adding == false || !allDocumentChosen" class="green" @click=" save()">{{
                    'Save' | lang }} </button>

            </div>
        </div>
    </div>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'
import saleableServices from '@/mixins/services/saleableServices'


export default {
    name: 'DettaglioDocumenti',
    mixins: [dialogMixin, saleableServices],
    props: ['order', 'orderItem', 'evidences'],
    computed: {

        allDocumentChosen() {
            if (this.documentsNeeded) {

                for (let i = 0; i < this.documentsNeeded.length; i++) {
                    if (this.documentsNeeded[i]) {
                        if (!(this.documentsNeeded[i].Documents.length > 0 && this.documentsNeeded[i].Documents[0].Name)) {
                            return false
                        }
                    }
                }
            }
            return true
        }
    },
    data() {
        return {

            adding: false,
            stateRefused: 'refused',
            documentsNeeded: []
        }
    },
    mounted() {
        var document = [];
        if (this.evidences && this.evidences[0].Evidences) {
            {
                for (var i = 0; i < this.evidences[0].Evidences.length; i++) {
                    var evidence = JSON.parse(JSON.stringify(this.evidences[0].Evidences[i]));
                    evidence.Documents = [];
                    if (evidence.State == this.stateRefused ) {
                        document[i] = evidence;
                    }
                }
            }
            this.documentsNeeded = document;
        }
    },
    methods: {
        async chooseFile(evt, idx) {
            let maxsize = this.manifest.document.maxSize; // in KB
            let allowedTypes = this.manifest.document.acceptFormats.split(',');
            let files = evt.srcElement.files
            let file = null
            if (files && files.length) {
                file = files[0]
            }
            if (file.size > 1024 * maxsize) {
                evt.target.value = null
                this.internalBus.$emit('notify:error', {
                    text: this.dictValue('excessive_file_size', { maxsize }),
                    key: this.notifierKey,
                    timeout: 3000
                })
                return
            }
            const name=file.name;
            const lastDot = name.lastIndexOf('.');
            const extension = "."+ name.substring(lastDot + 1).toLowerCase();
         if (!allowedTypes.includes(extension)) {          
                evt.target.value = null
                this.internalBus.$emit('notify:error', {
                    text: this.dictValue('documentFormatNotValid', null, { formats: this.manifest.document.acceptFormats }),
                    key: this.notifierKey,
                    timeout: 5000
                })
                return
            }
            if (!file) {
                return
            }

            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            })

            this.adding = true;
            let nameArray = file.name.split('.')
            let ext = nameArray.length > 1 ? nameArray[nameArray.length - 1] : file.type.split('/')[1]
            this.documentsNeeded[idx].Documents = [{
                DataFile: await toBase64(file),
                Name: file.name,
                Type: ext,
                Size: file.size,
                Id: this.evidences[0].Evidences[idx].Documents[0].Id
            }]
            this.documentsNeeded[idx].Documents[0].DataFile = this.documentsNeeded[idx].Documents[0].DataFile.split(';base64,')[1]
        },
        save() {
            var dataToUpdate = {
                EvidenceNumber: this.evidences[0].EvidenceNumber,
                Evidences: this.documentsNeeded.filter(x => x != null)
            }
            this._postEvidences(this.order.OrderId, this.orderItem.Id, dataToUpdate)
                .then(() => {
                    this.internalBus.$emit('notify:success', {
                        text: this.dictValue('Saved'),
                        key: this.notifierKey,
                        timeout: 3000
                    })
                    this.sweetClose(true);
                })
                .catch((e) => {
                    this.internalBus.$emit('notify:error', {
                        text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : '')
                    })

                })
        }
    }

}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';
$dett_sto_width: 50rem;

.evidences-dialog .dialog-content {
    min-width: $dett_sto_width;
    width: $dett_sto_width;
    max-width: $dett_sto_width;
}

#app.mobile .evidences-dialog .dialog-content {
    min-width: calc(100vw - 2rem);
    width: calc(100vw - 2rem);
    max-width: calc(100vw - 2rem);
}

#app.desktop .evidences-dialog .dialog-content .nav li {
    cursor: default;
}</style>
